module.exports = __webpack_public_path__ + "c4bddca4aa5b33284899c8f5342a3feb.svg";